// extracted by mini-css-extract-plugin
module.exports = {"paymentFormWrapper":"CardForm_paymentFormWrapper__2DeK4"};